import split from 'lodash/split';
import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { setChannelForTechnicalExp } from '../../lib/page';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const ARTICLE_URL = '/smarthelp/article-content';

function requestArticle() {
  return {
    type: types.REQUEST_ARTICLE,
    payload: undefined,
  };
}

function receiveArticle(responseData) {
  return {
    type: types.RECEIVE_ARTICLE_RESPONSE,
    payload: responseData,
  };
}

function receiveArticleError() {
  return {
    type: types.RECEIVE_ARTICLE_ERROR,
    payload: undefined,
  };
}


function fetchArticle(faqId, checkTechnical = false) {
  return (dispatch) => {
    dispatch(requestArticle());
    const faq = split(faqId, ',')[0];
    let articleURL = `${ARTICLE_URL}?article_id=${faq}`;

    if (checkTechnical) {
      articleURL = setChannelForTechnicalExp(articleURL);
    }

    return axios.get(articleURL, {
      cancelToken: source.token,
    })
    .then(response => (
      dispatch(receiveArticle(response.data.articleContent))
    ))
    .catch(() => {
      dispatch(receiveArticleError());
    });
  };
}

function cancelArtilceRequest() {
  source.cancel('article request canceled.');
}

module.exports = {
  receiveArticleError,
  fetchArticle,
  cancelArtilceRequest,
};
